import Confirm from "./Confirm";
import Modal from "../Modal";
interface Additions {
  Confirm: typeof Confirm;
}

const ModalConfirm: typeof Modal & Additions = Object.assign(Modal, {
  Confirm: Confirm,
});

export default ModalConfirm;
